export default __webpack_public_path__ + "static/media/ADWEEK.275a2b05.png";